import Menu from 'components/Menu';
import RoundyContainer from 'components/RoundyContainer'
import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import { storageData } from "services/Services"
import { HouseholdChangeContext, HouseholdChangeContextComp } from 'components/StraightThroughHouseholdComp/HouseholdContext/HouseholdChangeContext'
import HouseholdSummaryMain from 'components/StraightThroughHouseholdComp/5_Summary/HouseholdSummaryMain';
import { AddressChangeContextComp } from 'components/StraightThroughAddressComp/AddressContext/AddressChangeContext';

const HouseholdSummary = (props) => {
    const navigate = useNavigate();
    const { userData } = props.user
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for Add Vehicle Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementRemoveVehicle")) {
            navigate("/maintenance")
            return
        }
    }, [])
    
    const Container = props.isHousehold ? HouseholdChangeContextComp : AddressChangeContextComp;

    return (
        <>
            <Container>
                <Menu Title={props.isHousehold?"UPDATE HOUSEHOLD":"ADDRESS CHANGE"} FirstName={userData.firstName} userData={userData} />
                <RoundyContainer Content={HouseholdSummaryMain} NoRoundy
                    params={{
                        storedData: { ...props.storedData },
                        setStoredData: props.setStoredData
                    }}
                />
            </Container>
        </>
    )
}

export default HouseholdSummary